import Media from './media'
import News from './news'
import Recruitment from './recruitment'
import { APIClient } from '@/infrastructure/network/Upstream/APIClient'

export default class UpstreamGateway {
  apiClient: APIClient
  Media: Media
  News: News
  Recruitment: Recruitment

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
    this.Media = new Media(apiClient)
    this.News = new News(apiClient)
    this.Recruitment = new Recruitment(apiClient)
  }
}
